import React, { useState, useCallback } from "react";
import Cropper from "react-easy-crop";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Slider } from "@/components/ui/slider";

const ASPECTS = [["Свободно", null], ["1:1", 1], ["4:3", 4 / 3], ["16:9", 16 / 9], ["3:4", 3 / 4]];

async function cropToBlob(src, area, type = "image/jpeg") {
  const img = await new Promise((res, rej) => { const i = new Image(); i.crossOrigin = "anonymous"; i.onload = () => res(i); i.onerror = rej; i.src = src; });
  const canvas = document.createElement("canvas");
  const max = 2400, k = Math.min(1, max / Math.max(area.width, area.height));
  canvas.width = Math.round(area.width * k); canvas.height = Math.round(area.height * k);
  canvas.getContext("2d").drawImage(img, area.x, area.y, area.width, area.height, 0, 0, canvas.width, canvas.height);
  return new Promise((res) => canvas.toBlob(res, type === "image/png" ? "image/png" : "image/jpeg", 0.9));
}

export function ImageCropDialog({ src, type, onCancel, onDone }) {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [aspect, setAspect] = useState(4 / 3);
  const [area, setArea] = useState(null);
  const [busy, setBusy] = useState(false);
  const onComplete = useCallback((_, px) => setArea(px), []);
  const apply = async () => {
    setBusy(true);
    try { onDone(await cropToBlob(src, area, type)); } catch (e) { onDone(null, e); } finally { setBusy(false); }
  };
  return (
    <Dialog open={!!src} onOpenChange={(o) => !o && onCancel()}>
      <DialogContent className="max-w-2xl" data-testid="crop-dialog">
        <DialogHeader><DialogTitle>Изрязване на снимката</DialogTitle></DialogHeader>
        <div className="relative h-80 bg-black/80 rounded-xl overflow-hidden">
          {src && <Cropper image={src} crop={crop} zoom={zoom} aspect={aspect || undefined} onCropChange={setCrop} onZoomChange={setZoom} onCropComplete={onComplete} />}
        </div>
        <div className="flex flex-wrap gap-2">
          {ASPECTS.map(([l, a]) => (
            <button key={l} onClick={() => setAspect(a)} className={`px-3 py-1 rounded-lg text-sm border ${aspect === a ? "bg-forest text-white" : "border-gold/30"}`}>{l}</button>
          ))}
        </div>
        <div className="flex items-center gap-3 text-sm">Мащаб <Slider min={1} max={4} step={0.05} value={[zoom]} onValueChange={([v]) => setZoom(v)} /></div>
        <DialogFooter>
          <Button variant="outline" onClick={onCancel}>Отказ</Button>
          <Button onClick={apply} disabled={busy || !area} className="bg-forest text-white" data-testid="crop-apply">Приложи</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
